import React from 'react';


export default function ModalBackdrop() {
  return <div className="modal-backdrop in"></div>;
}



/** WEBPACK FOOTER **
 ** ./src/components/ModalBackdrop.js
 **/